import { Injectable } from '@angular/core';
import { PopupFeatures, PopupService } from '@platform-frontend/ui-tools';
import { Observable } from 'rxjs';
import { OAuthProvider } from './model/o-auth-provider';
import { IOAuthPopupService } from './o-auth-popup-service';

@Injectable({
  providedIn: 'root'
})
export class OAuthPopupService implements IOAuthPopupService {
  constructor(private popupService: PopupService) {}

  private readonly O_AUTH_POPUP: string = 'o-auth';

  openOrNavigateOAuthPopup(url: string, provider: OAuthProvider, closeOnLoadedMessage?: boolean): void {
    this.popupService.openOrNavigate(this.O_AUTH_POPUP, url, this.createOAuthPopupFeatures(provider), closeOnLoadedMessage);
  }

  private createOAuthPopupFeatures(provider: OAuthProvider): PopupFeatures {
    switch (provider) {
      case 'FACEBOOK':
        return new PopupFeatures(1000, 860);
      case 'MICROSOFT':
        return new PopupFeatures(440, 630);
      case 'GITHUB':
        return new PopupFeatures(600, 770);
      case 'GOOGLE':
        return new PopupFeatures(600, 650);
      case 'LINKEDIN':
        return new PopupFeatures(980, 660);
      case 'APPLE':
        return new PopupFeatures(780, 690);
    }
  }

  isNavigationInPopupPossible(): boolean {
    return true;
  }

  closedByUser(): Observable<unknown> {
    return this.popupService.closedByUser(this.O_AUTH_POPUP);
  }

  close(): void {
    this.popupService.close(this.O_AUTH_POPUP);
  }
}
